import app from '../app.first';
import { each } from 'lodash';

app.IndustryBreakdown = class extends app.Component {
	onReady($this) {
		app.ajax('/recruiter/search/search-results-by-industry.json' + window.location.search, null, false)
			.then(r => {
				if (r && r.countData) {
					each(r.countData, (industry, i) => {
						let $card = this.$el.find('.count-card').eq(i);

						if (!$card.length) {
							return;
						}

						$card.find('.count-number').removeClass('hide').text(industry.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
						$card.find('.count-name').removeClass('hide').text(industry.title).trigger('classChange');
						$card.find('img').remove();
					});
				}
				this.$el.find('.count-card img').parents('.cell').remove();
			});
	}
}